import React, { useEffect, useRef } from 'react';
import BasicSelectProps from './BasicSelect.types';
import dispatchDOMEvent from '../../../../utils/dispatchDomEvent';

const BasicSelect = ({
  options = [],
  selectedValue,
  id,
  name,
  onChange,
  dataPointer,
  nullText,
  initialiseAsNull,
  dataCy = 'basicSelect',
}: BasicSelectProps) => {
  const selectboxBrowserDefault = useRef(null);

  useEffect(() => {
    if (selectboxBrowserDefault.current) {
      dispatchDOMEvent(selectboxBrowserDefault.current, 'change');
    }
  }, []);

  return (
    <select
      ref={selectboxBrowserDefault}
      id={id}
      name={name}
      onChange={onChange}
      data-pointer={dataPointer}
      defaultValue={selectedValue}
      data-cy={dataCy}>
      {initialiseAsNull ? (
        <option aria-label='void' value=''>
          {nullText ?? ''}
        </option>
      ) : null}
      {options.map((option) => {
        const value = typeof option !== 'string' ? `${option.const || option.title}` : option;
        const key = typeof option !== 'string' ? `${option.const}${option.title}` : option;
        return (
          <option value={value} key={key}>
            {typeof option !== 'string' ? option.title : option}
          </option>
        );
      })}
    </select>
  );
};

export default BasicSelect;
